import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useRequestAccountDeletionMutation } from 'src/api/v2/profile-settings-v2-ApiSlice';
import { SettingsSection } from 'src/pages/ProjectSettingsPage/components/SettingsSection';
import { AccountIcon } from 'src/icons/AccountIcon';
import { DeleteAccountDialog } from 'src/pages/ProfileSettingsPage/components/DeleteAccountDialog';
import { FeedbackSurveyDialog } from 'src/pages/ProfileSettingsPage/components/FeedbackSurveyDialog';
import { useAppDispatch } from 'src/app/hooks';
import { showSnackBar } from 'src/api/ui-slice';
import { ts } from 'src/utils/translate';

export const AccountActionsSection = () => {
    const dispatch = useAppDispatch();
    const [requestAccountDeletion, { isLoading }] = useRequestAccountDeletionMutation();
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [isSurveyOpen, setSurveyOpen] = useState(false);

    const handleDeleteConfirm = () => {
        requestAccountDeletion()
            .unwrap()
            .then(() => {
                setDeleteDialogOpen(false);
                setSurveyOpen(true);
            })
            .catch((error) => {
                setDeleteDialogOpen(false);
                if (error?.data?.errorMessage == null) {
                    dispatch(showSnackBar({
                        text: ts('profile_settings_save_error', 'Failed to save profile settings'),
                        severity: 'error',
                    }));
                }
            });
    };

    const handleSurveyClose = () => {
        setSurveyOpen(false);
        dispatch(showSnackBar({
            text: ts('profile_settings_check_email', 'Check your email for further instructions.'),
            severity: 'success',
        }));
    };

    return (
        <SettingsSection title={ts('profile_settings_account_actions', 'Account Actions')} titleIcon={<AccountIcon />}>
            <Button
                variant="outlined"
                color="primary"
                sx={{ textTransform: 'uppercase' }}
                onClick={() => setDeleteDialogOpen(true)}
            >
                {ts('profile_settings_delete_account', 'Delete Account')}
            </Button>
            <DeleteAccountDialog
                open={isDeleteDialogOpen}
                disabled={isLoading}
                onClose={() => setDeleteDialogOpen(false)}
                onConfirm={handleDeleteConfirm}
            />
            <FeedbackSurveyDialog open={isSurveyOpen} onClose={handleSurveyClose} />
        </SettingsSection>
    );
};
